import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { TrendIcon } from './domain-overview-trend-icon.atom'
import type { DomainOverviewMetric } from './split-view.interface'

export interface MetricCardProps {
  metric: DomainOverviewMetric
}

export const MetricCard: React.FC<MetricCardProps> = ({ metric }): ReactNode => (
  <div className="domain-metric flex flex-col gap-1 rounded-lg border bg-card p-3">
    <span className="text-xs text-muted-foreground">{metric.label}</span>
    <div className="flex items-center gap-2">
      <span className="text-lg font-semibold">{metric.value}</span>
      {metric.change && (
        <div className="flex items-center gap-0.5">
          <TrendIcon trend={metric.trend} />
          <span
            className={cn(
              'text-xs',
              metric.trend === 'up' && 'text-green-500',
              metric.trend === 'down' && 'text-red-500',
              metric.trend === 'neutral' && 'text-muted-foreground'
            )}
          >
            {metric.change}
          </span>
        </div>
      )}
    </div>
  </div>
)
